import React from "react";

export default function CompanyDashboard(props) {
  return <div></div>;
}
